import { selectDeviceTypeIsMobile } from 'selectors/app'
import { fetchTicketOnDesktop } from './fetchTicketOnDesktop'
import { fetchTicketOnMobile } from './fetchTicketOnMobile'

export function doFetchTicket(ticketId, options = {}) {
  return (dispatch, getState) => {
    if (!ticketId || ticketId === 'new') return false

    const state = getState()
    const isOnMobile = selectDeviceTypeIsMobile(state)
    const fetchFunc = isOnMobile ? fetchTicketOnMobile : fetchTicketOnDesktop
    return fetchFunc(dispatch, state, ticketId, options)
  }
}
